import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import aes from './utils/aes.js'
Vue.config.productionTip = false
import axios from "axios"
Vue.prototype.$http = axios

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import echarts from "echarts"
// import '../public/css/index.css';
Vue.prototype.$echarts = echarts

import Print from 'vue-print-nb'
Vue.use(Print);

import '../public/css/global.css'

import _lo from 'lodash'
Vue.prototype._lo = _lo

import Moment from 'moment'
Vue.prototype.$moment = Moment

import sanitize from './utils/sanitize.js'
// FIX-11：v-html 统一走 $sanitize（DOMPurify）清洗，防存储型 XSS
Vue.prototype.$sanitize = sanitize

Vue.prototype.$pdfUrl = 'http://frp.aiwx.org.cn:10021'
// Vue.prototype.$pdfUrl = 'http://127.0.0.1:20021'

//获取用户token
let token = null;
let getToken = async _ => {
	if (localStorage.getItem("auth")) {//从session中取到token后，再解密
		token = await aes.decrypt(localStorage.getItem("auth"))
	}
	return new Promise(resolve => {
		resolve(token)
	})
}

axios.interceptors.request.use(async req => {
	
	//生成 c s f r 校验
	let v = String.fromCharCode(90 + 9) + String.fromCharCode(100 + 15) + String.fromCharCode(100 + 7 * 2) +
		String.fromCharCode(51 * 2)
	let c = {}
	let d = new Date()
	c[v] = d.getTime() + "_" + parseInt(Math.random() * 100000);
	c[v] = await aes.encrypt(c[v])
	let hour = d.getHours(),
		min = d.getMinutes(),
		sec = d.getSeconds();
	hour < 10 ? hour = '0' + hour : true;
	min < 10 ? min = '0' + min : true;
	sec < 10 ? sec = '0' + sec : true;
	c["_" + v] = await aes.encrypt(hour + ":" + min + ":" + sec)
	req.headers[v] = c[v] + "_" + c["_" + v]

	//todo del token
	req.headers["Authorization"] = await getToken();

	let year = sessionStorage.getItem("year");
	if (year) {
		if(req.data){
			req.data.year = year
		}else{
			req.data={year}
		}
	}else{
		sessionStorage.setItem("year",new Date().getFullYear());
	}

	

	if (req.url.indexOf("http") >= 0) {

	} else {
		if (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("192.168") > 0) {
			req.url = "http://127.0.0.1:11050" + req.url
		} else {
			req.url = "//api-qsx-jyj.qushixi.org.cn" + req.url
		}
	}
	// if (req.data) req.data.debug = 1
	if (req.data && !req.data.noloading) {
		$("#loading").show();
	}
	return req
}, error => {
	return Promise.reject(error)
});

axios.interceptors.response.use(async response => {
	$("#loading").hide();

	if (response.data.code == 401 || response.data.name == 'TokenExpiredError') {
		localStorage.clear();
		console.log(105105105,'/login')
		window.location.href = "/#/login"
	} else {

		if (response.data.code && response.data.code != 200) {
			$("#errdg").text(response.data.msg).show(); // FIX-11：msg 可能为服务端可控文本，改 text 防注入
			$('#mask').show()
			setTimeout(() => {
				$("#errdg").hide()
				$("#mask").hide()
			}, 3000)
			return Promise.reject(null)
		} else {
			if (response.data.raw) {
				
				response.data = await aes.decrypt(response.data.raw)
			
				try {
					response.data = JSON.parse(response.data)
				} catch (error) {
					
				}
			}
			return response
		}

	}
}, error => {
	console.log(error)
	if (error.response && error.response.status == 401) {
		localStorage.clear();
		console.log(136136136, '/login')
		window.location.href = "/#/login"
	} else {
		return Promise.reject(error)
	}

})



Vue.prototype.uploadTemp = (fileObj) => {
	axios.post("/api/oss_temp_sign").then(osstoken => {
		var myDate = new Date();
		var ossPath = 'files/' + myDate.getFullYear() + "-" + (myDate.getMonth() + 1);
		// 获取文件后缀
		var pathArr = fileObj.file.name.split('.')
		//  随机生成文件名称
		var fileRandName = Date.now() + "" + parseInt(Math.random() * 1000)
		var fileName = fileRandName + '.' + pathArr[pathArr.length - 1]
		// 要提交的key
		var fileKey = ossPath + "/" + fileName;
		let formData = {
			name: fileObj.file.name,
			key: fileKey,
			policy: osstoken.data.policy,
			OSSAccessKeyId: osstoken.data.accessid,
			signature: osstoken.data.signature,
			success_action_status: "200",

		};
		var host = osstoken.data.region;
		var outurl = host
		var form = new FormData();
		// 其他参数
		for (let k in formData) {
			form.append(k, formData[k]);
		}
		form.append("file", fileObj.file);
		// XMLHttpRequest 对象
		var xhr = new XMLHttpRequest();
		xhr.open("post", host, true);
		xhr.upload.addEventListener("progress", fileObj.onProgress, false); //监听上传进度
		xhr.onload = (res) => {
			if (fileObj.onSuccess) {


				fileName = fileName.toLocaleLowerCase();
				//计算图片高度
				if (fileName.indexOf(".jpg") > 0 || fileName.indexOf(".jpeg") > 0 || fileName.indexOf(".png") > 0 || fileName
					.indexOf(
						".gif") > 0 || fileName.indexOf(".bmp") > 0) {

					var reader = new FileReader();
					reader.readAsDataURL(fileObj.file);
					reader.onload = function (theFile) {
						var image = new Image();
						image.src = theFile.target.result;
						image.onload = function () {
							fileObj.onSuccess({
								src: outurl + "/" + fileKey + "?s=" + this.width + "_" + this.height,
								fileName: fileObj.file.name
							})

						};
					};

				} else {
					fileObj.onSuccess({
						src: outurl + "/" + fileKey,
						fileName: fileObj.file.name
					})
				}

			}
		};
		xhr.onerror = res => {
			if (fileObj.onError) {
				fileObj.onError(res)
			}

		}
		xhr.send(form);
	});
}


Vue.prototype.uploadOss = (fileObj) => {
	axios.post("/api/oss_comm_sign").then(osstoken => {
		var myDate = new Date();
		var ossPath = 'files/' + myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate();
		// 获取文件后缀
		var pathArr = fileObj.file.name.split('.')
		//  随机生成文件名称
		var fileRandName = Date.now() + "" + parseInt(Math.random() * 1000)
		var fileName = fileRandName + '.' + pathArr[pathArr.length - 1]
		// 要提交的key
		var fileKey = ossPath + "/" + fileName;
		let formData = {
			name: fileObj.file.name,
			key: fileKey,
			// FIX-20260918（审计-上传覆盖）：携带服务端 10 分钟短时签名（原 2035 永久 policy 残留注释已删除），
			// 服务端 policy 已限定 files/ 前缀，配合上传代理侧校验可防覆盖任意对象
			policy: osstoken.data.policy,
			OSSAccessKeyId: osstoken.data.accessid,
			signature: osstoken.data.signature,
			success_action_status: "200",
			app: "qsxjyj"

		};
		var host = osstoken.data.uploadUrl;
		var outurl = host
		var form = new FormData();
		// 其他参数
		for (let k in formData) {
			form.append(k, formData[k]);
		}
		form.append("file", fileObj.file);
		// XMLHttpRequest 对象
		var xhr = new XMLHttpRequest();
		xhr.open("post", host, true);
		xhr.upload.addEventListener("progress", fileObj.onProgress, false); //监听上传进度
		xhr.onload = (res) => {
			if (fileObj.onSuccess) {
				let resObj = res.currentTarget.responseText
				try {
					resObj = JSON.parse(resObj)
				} catch (e) {
					resObj = {}
				}
				resObj.size = fileObj.file.size;
				fileName = fileName.toLocaleLowerCase();
				//计算图片高度
				if (fileName.indexOf(".jpg") > 0 || fileName.indexOf(".jpeg") > 0 || fileName.indexOf(".png") > 0 ||
					fileName
						.indexOf(
							".gif") > 0 || fileName.indexOf(".bmp") > 0) {

					var reader = new FileReader();
					reader.readAsDataURL(fileObj.file);
					reader.onload = function (theFile) {
						var image = new Image();
						image.src = theFile.target.result;
						image.onload = function () {
							if (resObj.src) {
								resObj.src += "?s=" + this.width + "_" + this.height
							}
							fileObj.onSuccess(resObj)

						};
					};

				} else {
					fileObj.onSuccess(resObj)
				}

			}
		};
		xhr.onerror = res => {
			if (fileObj.onError) {
				fileObj.onError(res)
			}

		}
		xhr.send(form);

	});
}

function $$parent() {
	let parent = arguments[0];
	let func = arguments[1]
	let para = []
	for (let i = 2; i < arguments.length; i++) {
		para.push(arguments[i])
	}
	return new Promise(resolve => {
		let checkParent = idx => {
			if (parent.$parent && idx < 20) {
				parent = parent.$parent
				if (parent[func] !== undefined) {
					if (typeof (parent[func]) == "function") {
						parent[func](...para)
						resolve(true)
					} else {
						if (arguments.length >= 3) {//判定是赋值
							parent[func] = arguments[2]
							resolve(parent[func])
						} else {//判定是读值
							resolve(parent[func])
						}

					}
				} else {
					checkParent(idx + 1)
				}
			} else {
				console.log("未找到：" + func)
				resolve(undefined)
			}
		}
		checkParent(0)
	}, reject => { })

}

Vue.prototype.$$parent = $$parent

Vue.prototype.$keepTwoDecimal = (num) => {
	var result = parseFloat(num);
	if (isNaN(result)) {
		return num;
	}
	result = Math.round(num * 100) / 100;
	return result;
}
Vue.prototype.decryptWord = async (word) => {
	if(word){
		return await aes.decryptWord(word)
	}else{
		return ""
	}
}

import { initTable } from './utils/FullScreen.js'
Vue.prototype.initFullTables = async () => {
	console.log('全屏111')
	const element = document.getElementById('myFullTable')
	initTable(element)
}

	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
